import { FC, PropsWithChildren, useEffect } from 'react';
import { MobileFooter } from './MobileFooter';
import {
  SimpleNavbar,
  SimpleNavbarProps,
} from '../../../components/SimpleNavbar/SimpleNavbar';
import classNames from 'classnames';
import DesktopFooter from './DesktopFooter';
import styles from './BasicLayout.module.scss';
import useAuth from 'ui/hooks/useAuth';
import VersionInfo from '../Frame/VersionInfo/VersionInfo';

export interface BasicLayoutProps {
  pageTitle?: string;
}

export const BasicLayout: FC<
  PropsWithChildren<BasicLayoutProps> & SimpleNavbarProps
> = (props) => {
  const { logout } = useAuth();
  const { pageTitle, children, onBack } = props;

  const logoutClicked = () => {
    logout();
  };

  useEffect(() => {
    if (pageTitle !== undefined) {
      document.title = pageTitle;
    }
  }, [pageTitle]);

  return (
    <div className={classNames(styles['wrapper'])}>
      <VersionInfo />
      <div className={classNames(styles['body'])}>
        <SimpleNavbar onBack={onBack} />
        <div
          className={classNames(
            styles['body-wrapper'],
            // footerCenter ? styles['body-wrapper--center'] : undefined,
          )}
        >
          {children}
        </div>
        <div className={styles['desktop-footer-container']}>
          <DesktopFooter />
        </div>
        <MobileFooter onLogoutClick={logoutClicked} />
      </div>
    </div>
  );
};
